// extracted by mini-css-extract-plugin
export default {"card":"Card_card__B-vCh","cardImage":"Card_cardImage__3HRHi","cardContent":"Card_cardContent__-sWuD","cardTitle":"Card_cardTitle__UNKYo"};